<div class="short-long">
  <div class="content">
    <ng-container *ngIf="!isShowingFull; else showingFull">
      <div class="short-long-description-text" [innerHtml]="description | truncate : descriptionLengthByScreenSize : '...' : 'html' | safeHtml"></div>
    </ng-container>
    <ng-template #showingFull>
      <div class="short-long-description-text" [innerHtml]="description | safeHtml"></div>
    </ng-template>
  </div>

  <div class="btn btn-toggle" *ngIf="isShowingToggleButton" (click)="toggleDisplayingOption()">
    {{ toggleButtonContent }}
  </div>
</div>
